var _a, _b, _c, _d, _e;
import { ThemeBreakpoints } from '../breakpoints';
export var tabSizes = (_a = {},
    _a[ThemeBreakpoints.SMALL] = {
        padding: '8px 16px',
        fontSize: '14px',
    },
    _a[ThemeBreakpoints.MEDIUM] = {
        padding: '8px 16px',
        fontSize: '16px',
    },
    _a[ThemeBreakpoints.LARGE] = {
        padding: '8px 16px',
        fontSize: '16px',
    },
    _a[ThemeBreakpoints.MOBILE] = {
        padding: '8px 16px',
        fontSize: '16px',
    },
    _a);
export var tabActiveSizes = (_b = {},
    _b[ThemeBreakpoints.SMALL] = {
        padding: '14px 16px',
    },
    _b[ThemeBreakpoints.MEDIUM] = {
        padding: '14px 16px',
    },
    _b[ThemeBreakpoints.LARGE] = {
        padding: '14px 16px',
    },
    _b[ThemeBreakpoints.MOBILE] = {
        padding: '14px 16px',
    },
    _b);
export var tabSecondarySizes = (_c = {},
    _c[ThemeBreakpoints.SMALL] = {
        height: '36px',
    },
    _c[ThemeBreakpoints.MEDIUM] = {
        height: '36px',
    },
    _c[ThemeBreakpoints.LARGE] = {
        height: '36px',
    },
    _c[ThemeBreakpoints.MOBILE] = {
        height: '36px',
    },
    _c);
export var tabCloseButtonSizes = (_d = {},
    _d[ThemeBreakpoints.SMALL] = {
        fontSize: '14px',
    },
    _d[ThemeBreakpoints.MEDIUM] = {
        fontSize: '14px',
    },
    _d[ThemeBreakpoints.LARGE] = {
        fontSize: '14px',
    },
    _d[ThemeBreakpoints.MOBILE] = {
        fontSize: '14px',
    },
    _d);
export var tabBadgeSizes = (_e = {},
    _e[ThemeBreakpoints.SMALL] = {
        padding: '0 8px',
    },
    _e[ThemeBreakpoints.MEDIUM] = {
        padding: '0 8px',
    },
    _e[ThemeBreakpoints.LARGE] = {
        padding: '0 8px',
    },
    _e[ThemeBreakpoints.MOBILE] = {
        padding: '0 8px',
    },
    _e);
